import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Building2, Activity, AlertTriangle,
  MessageSquare, RefreshCw, LogOut,
} from 'lucide-react';
import { signOut } from 'aws-amplify/auth';

const NAV_ITEMS = [
  { to: '/',          label: 'Dashboard',  Icon: LayoutDashboard, end: true },
  { to: '/accounts',  label: 'Accounts',   Icon: Building2 },
  { to: '/jobs',      label: 'Jobs',       Icon: Activity },
  { to: '/errors',    label: 'Errors',     Icon: AlertTriangle },
  { to: '/feedback',  label: 'Feedback',   Icon: MessageSquare },
  { to: '/reprocess', label: 'Reprocess',  Icon: RefreshCw },
];

export default function Sidebar({ userEmail }: { userEmail: string }) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
    window.location.reload();
  };

  return (
    <nav style={{
      position: 'fixed',
      left: 0,
      top: 0,
      height: '100vh',
      width: 'var(--sidebar-width)',
      background: 'var(--bg-card)',
      borderRight: '1px solid var(--border)',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
    }}>
      {/* Logo */}
      <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid var(--border)' }}>
        <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: '-0.02em' }}>
          verbat<span style={{ color: 'var(--accent)' }}>AI</span>m
        </div>
        <div style={{ fontSize: 10, color: 'var(--text-dim)', marginTop: 2, fontWeight: 600, letterSpacing: '0.08em' }}>
          ADMIN CONSOLE
        </div>
      </div>

      {/* Nav links */}
      <div style={{ flex: 1, padding: '12px 8px', overflow: 'auto' }}>
        {NAV_ITEMS.map(({ to, label, Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 12px',
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 500,
              color: isActive ? 'var(--text)' : 'var(--text-muted)',
              background: isActive ? 'var(--accent-subtle)' : 'transparent',
              borderLeft: isActive ? '2px solid var(--accent)' : '2px solid transparent',
              textDecoration: 'none',
              marginBottom: 2,
              transition: 'all 0.1s',
            })}
          >
            <Icon size={15} />
            {label}
          </NavLink>
        ))}
      </div>

      {/* Footer */}
      <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border)' }}>
        <div style={{ fontSize: 11, color: 'var(--text-dim)', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {userEmail}
        </div>
        <button
          onClick={handleSignOut}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 12,
            color: 'var(--text-muted)',
            background: 'none',
            border: 'none',
            padding: '4px 0',
            cursor: 'pointer',
          }}
        >
          <LogOut size={13} />
          Sign out
        </button>
      </div>
    </nav>
  );
}
